import { SUBJECT_OPTIONS } from '../../helpers/contactSupport';

export const mapToFormModel = (model) => {
    return {
        email: model.email || '',
        subject: model.subject || SUBJECT_OPTIONS[0].subject,
        message: model.message || '',
        enableTechnicalData: model.enableTechnicalData === false ? false : true
    };
};